const OurProcessSingle = (props) => {
  return (
    <div className="w-full md:w-1/2 lg:w-1/4 p-4 ">
      <div className="text-center h-full py-10 px-6 my-5 content-center flex flex-wrap flex-column align-center justify-center bg-primary-400 hover:bg-primary transition duration-500 shadow-lg">
        <div className="py-1 px-4 text-sm text-white font-bold uppercase mb-10 w-full group-hover:text-white transition duration-500">
          <props.process.icon2 className="mx-auto text-6xl" />
        </div>
        <div className="w-full mx-auto">
          <ul className="list-none p-0">
            <li className="mb-2">
              <p className="font-normal text-white text-lg">
                {props.process.headline}
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export { OurProcessSingle };
